import { chatMessagingPolicy } from './chat-messaging.js';
import { insightEdgeReadOnlyPolicy } from './insightedge.js';
import { defineBuiltinRole } from './types.js';

/**
 * The role every person has when using an application as an end user. It bundles what an end user
 * may see in InsightEdge (everything published, nothing that changes or publishes; drafts need View
 * unpublished, which Read Only leaves out) and what they could always do in chat: export, share and
 * copy. What else they may do in each application is defined as applications adopt roles.
 */
export const endUserRole = defineBuiltinRole({
  key: 'builtin:end-user',
  name: 'End User',
  description: 'A person using an application, with no management app access.',
  policies: [insightEdgeReadOnlyPolicy, chatMessagingPolicy],
});
